/**
 * URL工具函数 - 处理捐款详情页面的URL生成和解析
 */

// 生成捐款详情页面的URL路径
export const generateDonationUrl = (donation) => {
  if (!donation) return "";

  const title = donation.postType ;
  const id = donation.id || donation._id;

  if (!id) return "";

  

  return `/donationDetails/${title}_${id}`;
};

// 解析捐款详情页面的URL参数，返回捐款ID
export const parseDonationUrl = (urlParam) => {
  if (!urlParam) return null;

  // URL参数格式: 捐款名称_捐款id
  const lastUnderscoreIndex = urlParam.lastIndexOf("_");
  if (lastUnderscoreIndex === -1) return null;

  const id = urlParam.substring(lastUnderscoreIndex + 1);
  return id || null;
};

// 获取完整的捐款详情URL（用于分享等场景）
export const getFullDonationUrl = (
  donation,
  baseUrl = window.location.origin
) => {
  const path = generateDonationUrl(donation);
  return path ? `${baseUrl}${path}` : "";
};
